import { APP_COLORS } from '@/config/colors';

/**
 * @param colorName - nazwa koloru do sprawdzenia
 * @returns true jeśli kolor istnieje w APP_COLORS
 */
export const checkColorExists = (colorName: string): boolean => {
  const flatColors = flattenColors(APP_COLORS);
  return colorName in flatColors || colorName === 'transparent';
};

/**
 * @param colors - obiekt kolorów do spłaszczenia
 * @param prefix - prefiks dla kluczy
 * @returns płaska struktura kolorów
 */
export const flattenColors = (
  colors: Record<string, any>,
  prefix = '',
): Record<string, string> => {
  const result: Record<string, string> = {};

  for (const [key, value] of Object.entries(colors)) {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      if ('DEFAULT' in value) {
        // Jeśli ma DEFAULT, dodaj klucz bez prefiksu i z prefiksem
        const baseKey = prefix ? `${prefix}-${key}` : key;
        result[baseKey] = value.DEFAULT as string;

        // Dodaj pozostałe klucze z prefiksem
        const nested = flattenColors(
          Object.fromEntries(
            Object.entries(value).filter(([k]) => k !== 'DEFAULT'),
          ),
          baseKey,
        );
        Object.assign(result, nested);
      } else {
        // Rekurencyjnie spłaszcz zagnieżdżone obiekty
        const nested = flattenColors(value, prefix ? `${prefix}-${key}` : key);
        Object.assign(result, nested);
      }
    } else {
      // Wartość prymitywna
      const finalKey = prefix ? `${prefix}-${key}` : key;
      result[finalKey] = value as string;
    }
  }

  return result;
};
